module.exports = __webpack_public_path__ + "img/rainbow.be5030ca.webp";